export const turboTagTextSize = {
  header: {
    small: '0.675rem',
    default: '0.875rem',
  },
  dialog: {
    small: '0.75rem',
    default: '0.75rem',
  },
} as const;
